export class GoFrequencyResultsConstants {
    static readonly expireRedirectQueryParam = 'expireRedirect';
}
